import type { ShareFormat } from '@core/types/share'
import { MarkdownRenderer } from './renderers/MarkdownRenderer'

interface ContentRendererProps {
  source: string
  format?: ShareFormat
}

export function ContentRenderer({ source, format = 'md' }: ContentRendererProps) {
  switch (format) {
    case 'md':
    case 'mdc':
      return <MarkdownRenderer source={source} />
    default: {
      const _exhaustive: never = format
      throw new Error(`Unsupported format: ${_exhaustive}`)
    }
  }
}
